// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CardsGrid_wrapper__p-LD1","title":"CardsGrid_title__1lkzC","grid":"CardsGrid_grid__2_y4G"};